import type {
  FulfillmentTypeUpdateRequestType,
  FulfillmentTypeUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useFulfillmentTypeUpdate = (fulfillmentTypeId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: FulfillmentTypeUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `fulfillment-type/${fulfillmentTypeId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as FulfillmentTypeUpdateResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.FulfillmentType,
          fulfillmentTypeId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.FulfillmentType,
          fulfillmentTypeId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.FulfillmentType],
      });
    },
  });
};
